
import {mapState, mapMutations} from "vuex"

export default {
  nuxtI18n: {
    paths: {
      "en-ca": "/sitemap",
      "fr-ca": "/plan-site",
    },
  },
  data() {
    return {
      show: false,
    }
  },
  head() {
    return {
      title: this.$t("global.legalNav.sitemap"),
      meta: [
        {
          hid: "description",
          name: "description",
          content: "",
        },
        {
          hid: "og:description",
          name: "og:description",
          content: "",
        },
      ],
    };
  },
  mounted() {
    setTimeout(()=> this.setPageAnimation('animBanner'),500)
  },
  computed: {
    ...mapState(['pageScroll'])
  },
  methods:{
    ...mapMutations({
      setPageAnimation:'SET_PAGE_ANIMATION'
    })
  },
  watch:{
    pageScroll: function(){
      let haveShow = false
      if((this.$refs.animated?.getBoundingClientRect().bottom - window.innerHeight + 90) <= 0){
        this.show = true
        haveShow = true
      }
    }
  }
};
